import React from 'react';
import cl from './Terms.module.css';

const Terms = (props) => {
  return (
    <section className={cl.app_policy}>
      <h1>Conditions d'utilisation</h1>
       <h2>APERÇU</h2>
       <p>
         Ce site Web est exploité par {props.domain}. Dans tout le site, les
         les termes "nous", "notre" et "nos" désignent
         {props.domain} offre ce site Web, y compris toutes les informations, outils et
         services disponibles à partir de ce site pour vous, l'utilisateur, sous réserve de
         votre acceptation de tous les termes, conditions, politiques et avis énoncés
         ici.
       </p>

       <p>
         En visitant notre site et/ou en achetant quelque chose chez nous, vous vous engagez à
         notre "Service" et acceptez d'être lié par les termes et conditions suivants
         conditions ("Conditions d'utilisation", "Conditions"), y compris les conditions supplémentaires
         termes, conditions et politiques référencés ici et / ou disponibles par
         lien hypertexte. Ces conditions d'utilisation s'appliquent à tous les utilisateurs du site,
         y compris, sans s'y limiter, les utilisateurs qui sont des navigateurs, des fournisseurs, des clients,
         marchands et/ou contributeurs de contenu.
       </p>
       <p>
         Veuillez lire attentivement ces conditions d'utilisation avant d'accéder ou d'utiliser
         notre site Web. En accédant ou en utilisant n'importe quelle partie du site, vous acceptez d'être
         lié par les présentes conditions d'utilisation. Si vous n'acceptez pas toutes les conditions
         et conditions de cet accord, vous ne pouvez pas accéder au site Web ou
         utiliser n'importe quel service. Si ces conditions d'utilisation sont considérées comme une offre,
         l'acceptation est expressément limitée aux présentes conditions d'utilisation.
       </p>
       <p>
         Toutes les nouvelles fonctionnalités ou tous les nouveaux outils ajoutés au magasin actuel doivent
         également être soumis aux conditions d'utilisation. Vous pouvez consulter la plus récente
         version des conditions d'utilisation à tout moment sur cette page. Nous réservons le
         droit de mettre à jour, de modifier ou de remplacer toute partie de ces conditions d'utilisation par
         publier des mises à jour et/ou des modifications sur notre site Web. C'est votre responsabilité
         de vérifier périodiquement cette page pour les changements. Votre utilisation continue de ou
         l'accès au site après la mise en ligne d'éventuelles modifications vaut
         l'acceptation de ces changements.
       </p>
       <h2>SECTION 1 - CONDITIONS DE LA BOUTIQUE EN LIGNE</h2>
       <p>
         En acceptant ces conditions d'utilisation, vous déclarez que vous êtes à
         au moins l'âge de la majorité dans votre pays de résidence, ou que vous êtes
         l'âge de la majorité dans votre pays de résidence et vous nous avez donné
         votre consentement pour permettre à l'une de vos personnes à charge mineures d'utiliser ce site.
         <br />
         Vous ne pouvez pas utiliser nos produits à des fins illégales ou non autorisées ni
         pouvez-vous, dans l'utilisation du Service, violer les lois de votre
         juridiction (y compris, mais sans s'y limiter, les lois sur le droit d'auteur). Il ne faut pas
         transmettre des vers ou des virus ou tout code de nature destructrice. UN
         la violation ou la violation de l'une des Conditions entraînera une
         résiliation de vos Services.
       </p>
       <h2>ARTICLE 2 - CONDITIONS GÉNÉRALES</h2>
       <p>
         Nous nous réservons le droit de refuser le service à quiconque pour quelque raison que ce soit, à tout
         temps.
         <br />
         Vous comprenez que votre contenu (à l'exclusion des cartes de crédit
         informations), peuvent être transférés en clair et impliquent (a)
         transmissions sur divers réseaux ; et (b) des changements pour se conformer et
         s'adapter aux exigences techniques de connexion des réseaux ou des appareils.
         Les informations de carte de crédit sont toujours cryptées lors du transfert sur
         réseaux. Vous vous engagez à ne pas reproduire, dupliquer, copier, vendre, revendre ou
         exploiter toute partie du Service, l'utilisation du Service ou l'accès au
         Service ou tout contact sur le site Web par lequel le service est
         fournies, sans autorisation écrite expresse de notre part.
         <br />
         Les titres utilisés dans cet accord sont inclus pour des raisons de commodité uniquement
         et ne limitera ni n'affectera de quelque manière que ce soit les présentes Conditions.
       </p>
       <h2>SECTION 3 - EXACTITUDE, EXHAUSTIVITÉ ET ACTUALITÉ DES INFORMATIONS</h2>
       <p>
         Nous ne sommes pas responsables si les informations mises à disposition sur ce site ne sont pas
         exactes, complètes ou à jour. Le contenu de ce site est fourni pour
         informations générales uniquement et ne doivent pas être invoquées ou utilisées comme
         seule base pour prendre des décisions sans consultation primaire, plus
         des sources d'information exactes, plus complètes ou plus actuelles. N'importe lequel
         la confiance dans le matériel de ce site est à vos risques et périls.
         <br />
         Ce site peut contenir certaines informations historiques. Historique
         informations, nécessairement, ne sont pas à jour et sont fournies pour votre
         référence seulement. Nous nous réservons le droit de modifier le contenu de ce site
         à tout moment, mais nous n'avons aucune obligation de mettre à jour les informations sur notre
         placer. Vous convenez qu'il est de votre responsabilité de surveiller les changements apportés à notre
         placer.
       </p>
       <h2>ARTICLE 4 - MODIFICATIONS DU SERVICE ET DES PRIX</h2>
       <p>
         Les prix de nos produits sont sujets à changement sans préavis.
         <br />
         Nous nous réservons le droit à tout moment de modifier ou d'interrompre le Service
         (ou toute partie ou contenu de celui-ci) sans préavis à tout moment.
         <br />
         Nous ne serons pas responsables envers vous ou envers un tiers pour tout
         modification, changement de prix, suspension ou interruption du Service.
       </p>
       <h2>SECTION 5 - PRODUITS OU SERVICES (le cas échéant)</h2>
       <p>
         Certains produits ou services peuvent être disponibles exclusivement en ligne via
         le site Web. Ces produits ou services peuvent avoir des quantités limitées et
         ne peuvent être retournés ou échangés que conformément à notre politique de retour.
         <br />
         Nous nous sommes efforcés d'afficher le plus fidèlement possible les
         couleurs et images de nos produits qui apparaissent en magasin. Nous ne pouvons pas
         garantir que l'affichage de n'importe quelle couleur sur votre écran d'ordinateur sera
         précis.
         <br />
         Nous nous réservons le droit, mais ne sommes pas obligés, de limiter les ventes de nos
         produits ou Services à toute personne, région géographique ou juridiction.
         Nous pouvons exercer ce droit au cas par cas. Nous nous réservons le droit
         pour limiter les quantités de tous les produits ou services que nous proposons. Tous
         les descriptions des produits ou les prix des produits sont sujets à changement à
         à tout moment sans préavis, à notre seule discrétion. Nous réservons le
         droit d'interrompre tout produit à tout moment. Toute offre pour tout produit
         ou service rendu sur ce site est nul là où il est interdit.
         <br />
         Nous ne garantissons pas que la qualité des produits, services,
         informations, ou tout autre matériel acheté ou obtenu par vous répondra
         vos attentes, ou que toute erreur dans le Service sera corrigée.
       </p>
       <h2>SECTION 6 - EXACTITUDE DES INFORMATIONS DE FACTURATION ET DE COMPTE</h2>
       <p>
         Nous nous réservons le droit de refuser toute commande que vous passez chez nous. Nous pouvons, dans
         notre seule discrétion, limiter ou annuler les quantités achetées par personne,
         par foyer ou par commande. Ces restrictions peuvent inclure les commandes passées
         par ou sous le même compte client, la même carte de crédit, et/ou
         commandes qui utilisent la même adresse de facturation et/ou de livraison. Dans l'éventualité
         que nous modifions ou annulons une commande, nous pouvons essayer de notifier
         vous en contactant l'e-mail et/ou l'adresse de facturation/le numéro de téléphone
         fournies au moment de la commande. Nous nous réservons le droit de limiter
         ou interdire les commandes qui, à notre seul jugement, semblent avoir été passées par
         concessionnaires, revendeurs ou distributeurs.
       </p>
       <p>
         Vous acceptez de fournir des informations d'achat et de compte actuelles, complètes et exactes
         informations pour tous les achats effectués dans notre magasin. Vous vous engagez à promptement
         mettre à jour votre compte et d'autres informations, y compris votre adresse e-mail
         et les numéros de carte de crédit et les dates d'expiration, afin que nous puissions compléter
         vos transactions et vous contacter au besoin.
       </p>
       <p>Pour plus de détails, veuillez consulter notre politique de retour.</p>
       <h2>SECTION 7 - OUTILS OPTIONNELS</h2>
       <p>
         Nous pouvons vous donner accès à des outils tiers sur lesquels nous
         ni moniteur ni contrôle ni entrée.
         <br />
         Vous reconnaissez et acceptez que nous fournissons l'accès à ces outils "tels quels"
         et "tel que disponible" sans aucune garantie, représentation ou condition
         d'aucune sorte et sans aucune approbation. Nous n'aurons aucune responsabilité
         que ce soit résultant de ou lié à votre utilisation de tiers facultatifs
         outils.
         <br />
         Toute utilisation par vous des outils optionnels proposés sur le site est entièrement à votre
         vos propres risques et discrétion et vous devez vous assurer que vous êtes familier
         avec et approuver les conditions dans lesquelles les outils sont fournis par le
         fournisseur(s) tiers concerné(s).
         <br />
         Nous pouvons également, à l'avenir, proposer de nouveaux services et/ou fonctionnalités via
         le site Web (y compris la publication de nouveaux outils et ressources). Tel
         les nouvelles fonctionnalités et/ou services seront également soumis aux présentes conditions d'utilisation.
         Service.
       </p>
       <h2>SECTION 8 - LIENS TIERS</h2>
       <p>
         Certains contenus, produits et services disponibles via notre Service peuvent
         inclure des éléments provenant de tiers.
         <br />
         Des liens tiers sur ce site peuvent vous diriger vers des sites Web tiers
         qui ne nous sont pas affiliés. Nous ne sommes pas responsables de l'examen ou
         évaluer le contenu ou l'exactitude et nous ne garantissons pas et ne ferons pas
         avoir aucune responsabilité ou responsabilité pour tout matériel tiers ou
         sites Web, ou pour tout autre matériel, produit ou service de
         tiers.
         <br />
         Nous ne sommes pas responsables de tout préjudice ou dommage lié à l'achat ou à l'utilisation
         de biens, services, ressources, contenus ou toute autre transaction effectuée
         en relation avec des sites Web tiers. Veuillez lire attentivement le
         politiques et pratiques des tiers et assurez-vous de les comprendre
         avant de vous engager dans toute transaction. Plaintes, réclamations, préoccupations ou
         les questions concernant les produits tiers doivent être adressées au
         tierce personne.
       </p>
       <h2>SECTION 9 - COMMENTAIRES, RETOURS ET AUTRES SOUMISSIONS DES UTILISATEURS</h2>
       <p>
         Si, à notre demande, vous envoyez certaines soumissions spécifiques (par exemple
         participations au concours) ou sans demande de notre part, vous envoyez des idées créatives,
         suggestions, propositions, plans ou autres documents, que ce soit en ligne, par
         e-mail, par courrier postal ou autrement (collectivement, les « commentaires »), vous
         acceptez que nous puissions, à tout moment, sans restriction, éditer, copier,
         publier, distribuer, traduire et autrement utiliser sur tout support tout
         commentaires que vous nous transmettez. Nous ne sommes et ne serons sous aucune obligation
         (1) maintenir la confidentialité de tout commentaire ; (2) verser une indemnité pour
         tout commentaire; ou (3) pour répondre à tout commentaire.
         <br />
         Nous pouvons, sans y être obligés, surveiller, modifier ou supprimer le contenu qui
         nous déterminons à notre seule discrétion sont illégaux, offensants,
         menaçant, calomnieux, diffamatoire, pornographique, obscène ou autre
         répréhensible ou viole la propriété intellectuelle de toute partie ou ces
         Conditions d'utilisation.
         <br />
         Vous convenez que vos commentaires ne violeront aucun droit de
         tiers, y compris le droit d'auteur, la marque, la confidentialité, la personnalité ou
         autre droit personnel ou de propriété. Vous convenez en outre que votre
         les commentaires ne contiendront pas de propos diffamatoires ou autrement illégaux, abusifs ou
         matériel obscène, ou contenir tout virus informatique ou autre logiciel malveillant qui
         pourrait affecter de quelque manière que ce soit le fonctionnement du Service ou de tout
         site web. Vous ne pouvez pas utiliser une fausse adresse e-mail, prétendre être quelqu'un
         autre que vous-même, ou nous induire en erreur ou induire des tiers en erreur quant à la
         l'origine de tout commentaire. Vous êtes seul responsable des commentaires que vous
         faire et leur exactitude. Nous ne prenons aucune responsabilité et n'assumons aucune
         responsabilité pour tout commentaire publié par vous ou un tiers.
       </p>
       <h2>ARTICLE 10 - INFORMATIONS PERSONNELLES</h2>
       <p>
         Votre soumission d'informations personnelles via le magasin est régie par
         notre politique de confidentialité.
       </p>
       <h2>SECTION 11 - ERREURS, INEXACTITUDES ET OMISSIONS</h2>
       <p>
         Occasionnellement, il peut y avoir des informations sur notre site ou dans le Service qui
         contient des erreurs typographiques, des inexactitudes ou des omissions pouvant être liées
         aux descriptions de produits, aux prix, aux promotions, aux offres, à l'expédition des produits
         les frais, les temps de transit et la disponibilité. Nous nous réservons le droit de corriger
         toute erreur, inexactitude ou omission, et de modifier ou mettre à jour
         informations ou annuler des commandes si des informations dans le Service ou sur tout
         le site Web connexe est inexact à tout moment sans préavis
         (y compris après avoir soumis votre commande).
         <br />
         Nous n'assumons aucune obligation de mettre à jour, de modifier ou de clarifier les informations dans
         le Service ou sur tout site Web connexe, y compris, sans s'y limiter,
         informations sur les prix, sauf si la loi l'exige. Aucune mise à jour spécifiée ou
         la date d'actualisation appliquée dans le Service ou sur tout site Web connexe, doit être
         pris pour indiquer que toutes les informations dans le Service ou sur tout
         site Web a été modifié ou mis à jour.
       </p>
       <h2>SECTION 12 - UTILISATIONS INTERDITES</h2>
       <p>
         Outre les autres interdictions énoncées dans les Conditions d'utilisation,
         il vous est interdit d'utiliser le site ou son contenu : (a) à des fins
         but illicite ; (b) solliciter d'autres personnes pour exécuter ou participer à toute
         actes illégaux; (c) pour violer toute réglementation internationale ou britannique,
         règles, lois ou ordonnances locales ; (d) pour enfreindre ou violer nos
         droits de propriété intellectuelle ou les droits de propriété intellectuelle de
         autres; (e) harceler, abuser, insulter, blesser, diffamer, calomnier, dénigrer,
         intimider ou discriminer en fonction du sexe, de l'orientation sexuelle,
         religion, origine ethnique, race, âge, origine nationale ou handicap ; (f) à
         soumettre des informations fausses ou trompeuses ; (g) pour télécharger ou transmettre
         virus ou tout autre type de code malveillant qui sera ou pourra être utilisé dans
         de quelque manière que ce soit qui affectera la fonctionnalité ou le fonctionnement du Service
         ou de tout site Web connexe, d'autres sites Web ou d'Internet ; (h) à
         collecter ou suivre les informations personnelles d'autrui ; (i) pour spammer, hameçonner,
         pharm, prétexte, araignée, ramper ou gratter ; (j) pour tout acte obscène ou immoral
         but; ou (k) pour interférer avec ou contourner les fonctions de sécurité de
         le Service ou tout site Web connexe, d'autres sites Web ou Internet. Nous
         se réservent le droit de résilier votre utilisation du Service ou de tout
         site Web pour avoir enfreint l'une des utilisations interdites.
       </p>
       <h2>SECTION 13 - EXCLUSION DE GARANTIES ; LIMITATION DE RESPONSABILITE</h2>
       <p>
         Nous ne garantissons, ne représentons ni ne garantissons que votre utilisation de notre service
         sera ininterrompu, ponctuel, sécurisé ou sans erreur. Nous ne garantissons pas
         que les résultats qui peuvent être obtenus de l'utilisation du service seront
         être précis ou fiable.
         <br />
         Vous acceptez que de temps à autre nous puissions supprimer le service pour
         durée indéterminée ou annuler le service à tout moment, sans
         avis à vous.
         <br />
         Vous acceptez expressément que votre utilisation ou votre incapacité à utiliser le service
         est à vos risques et périls. Le service et tous les produits et services
         qui vous sont livrés via le service sont (sauf indication expresse par
         nous) fourni « tel quel » et « tel que disponible » pour votre usage, sans aucun
         représentation, garantie ou condition de quelque nature que ce soit, expresse ou
         implicite, y compris toutes les garanties ou conditions implicites de
         qualité marchande, qualité marchande, aptitude à un usage particulier,
         durabilité, titre et non-contrefaçon.
         <br />
         En aucun cas, nous, nos administrateurs, dirigeants, employés, sociétés affiliées,
         agents, sous-traitants, stagiaires, fournisseurs, prestataires de services ou concédants de licence
         être responsable de toute blessure, perte, réclamation ou de tout dommage direct, indirect,
         dommages accessoires, punitifs, spéciaux ou consécutifs de toute nature,
         y compris, sans s'y limiter, la perte de profits, la perte de revenus, la perte d'économies,
         perte de données, frais de remplacement ou tout autre dommage similaire, qu'il soit fondé
         contractuelle, délictuelle (y compris la négligence), responsabilité stricte ou autre,
         résultant de votre utilisation de tout service ou de tout produit acheté
         l'utilisation du service, ou pour toute autre réclamation liée de quelque manière que ce soit à votre utilisation
         du service ou de tout produit, y compris, mais sans s'y limiter, toute erreur
         ou omissions dans tout contenu, ou toute perte ou dommage de toute nature subi
         à la suite de l'utilisation du service ou de tout contenu (ou produit)
         posté, transmis ou autrement mis à disposition via le service, même
         s'ils sont avisés de leur possibilité. Étant donné que certains États ou juridictions
         n'autorise pas l'exclusion ou la limitation de responsabilité pour les
         ou dommages accessoires, dans ces états ou juridictions, notre responsabilité
         sera limité dans la mesure maximale autorisée par la loi.
       </p>
       <h2>ARTICLE 14 - INDEMNISATION</h2>
       <p>
         Vous acceptez de nous indemniser, de nous défendre et de nous dégager de toute responsabilité, ainsi que nos parents,
         filiales, sociétés affiliées, partenaires, dirigeants, administrateurs, agents,
         entrepreneurs, concédants, prestataires de services, sous-traitants, fournisseurs,
         stagiaires et employés, indemnes de toute réclamation ou demande, y compris
         honoraires d'avocat raisonnables, effectués par un tiers en raison de ou découlant
         de votre violation de ces conditions d'utilisation ou des documents qu'ils
         incorporer par référence, ou votre violation de toute loi ou des droits de
         une troisième fête.
       </p>
       <h2>ARTICLE 15 - DIVISIBILITÉ</h2>
       <p>
         Dans le cas où une disposition des présentes Conditions d'utilisation est déterminée
         être illégale, nulle ou inapplicable, cette disposition doit néanmoins
         être exécutoire dans toute la mesure permise par la loi applicable, et
         la partie inapplicable sera réputée séparée des présentes Conditions
         de service, une telle détermination n'affectera pas la validité et
         force exécutoire de toute autre disposition restante.
       </p>
       <h2>ARTICLE 16 - RÉSILIATION</h2>
       <p>
         Les obligations et responsabilités des parties contractées avant la
         la date de résiliation survivra à la résiliation de cet accord pour tous
         fins.
         <br />
         Ces conditions d'utilisation sont effectives à moins et jusqu'à ce qu'elles soient résiliées par
         soit vous, soit nous. Vous pouvez résilier ces conditions d'utilisation à tout moment
         en nous notifiant que vous ne souhaitez plus utiliser nos Services, ou lorsque vous
         cesser d'utiliser notre site.
         <br />
         Si, à notre seul jugement, vous ne parvenez pas, ou si nous soupçonnons que vous avez échoué, à
         respecter toute modalité ou disposition des présentes conditions d'utilisation, nous pouvons également
         résilier cet accord à tout moment sans préavis et vous resterez
         responsable de tous les montants dus jusqu'à et y compris la date de résiliation ;
         et/ou en conséquence peut vous refuser l'accès à nos Services (ou à toute partie
         celle-ci).
       </p>
       <h2>ARTICLE 17 - INTÉGRALITÉ DU CONTRAT</h2>
       <p>
         L'incapacité de notre part à exercer ou à appliquer tout droit ou disposition de ces
         Les conditions d'utilisation ne constituent pas une renonciation à ce droit ou
         disposition.
         <br />
         Ces conditions d'utilisation et toutes les politiques ou règles de fonctionnement publiées par nous
         sur ce site ou à l'égard du Service constitue l'intégralité
         l'accord et la compréhension entre vous et nous et régissent votre utilisation de
         le Service, annulant et remplaçant tous accords antérieurs ou contemporains,
         communications et propositions, orales ou écrites, entre vous et
         nous (y compris, mais sans s'y limiter, toute version antérieure des Conditions d'utilisation
         Service).
         <br />
         Toute ambiguïté dans l'interprétation des présentes conditions d'utilisation doit
         pas être interprétée contre le groupe de rédaction.
       </p>
       <h2>ARTICLE 18 - DROIT APPLICABLE</h2>
       <p>
         Ces conditions d'utilisation et tout accord séparé par lequel nous fournissons
         vos Services seront régis et interprétés conformément aux
         lois du Royaume-Uni.
       </p>
       <h2>SECTION 19 - MODIFICATIONS DES CONDITIONS D'UTILISATION</h2>
       <p>
         Vous pouvez consulter la version la plus récente des Conditions d'utilisation à tout moment.
         temps sur cette page. Nous nous réservons le droit, à notre entière discrétion, de
         mettre à jour, modifier ou remplacer toute partie de ces conditions d'utilisation en publiant
         mises à jour et modifications de notre site Web. Il vous appartient de vérifier
         périodiquement notre site Web pour des changements. Votre utilisation continue ou votre accès à
         notre site Web ou le Service suite à la publication de toute modification de ces
         Les conditions d'utilisation constituent une acceptation de ces modifications.
       </p>
       <h2>ARTICLE 20 - COORDONNÉES</h2>
       <p>
         Les questions concernant les conditions d'utilisation doivent nous être envoyées à soutien@
         {props.domain} Tous les éléments ci-dessus sont organisés et réglementés sous la
         lois du Royaume-Uni.
       </p>
    </section>
  );
};

export default Terms;
